export enum DisplayMode {
  LAYOUT_ONE = 'L1',
  LAYOUT_TWO = 'L2',
  LAYOUT_THREE = 'L3',
  LAYOUT_FOUR = 'L4',
  LAYOUT_FIVE = 'L5',
  LAYOUT_PD = 'PD',
  SERVICE_PLAN = 'SD',
}
